/**
 * Lowercase and accent-free, for matching what a person typed against a name they read on screen.
 *
 * Needed because the country names now come from `Intl.DisplayNames`: in Spanish and Portuguese they carry
 * diacritics ("México", "Perú", "Japón", "Bélgica") that nobody types into a search box. The ORDER of those
 * lists already ignored them — `Intl.Collator` with `sensitivity: "base"` — so this is the same rule applied
 * to matching, which is where it was missing.
 *
 * `\p{Diacritic}` over the NFD decomposition, the same pair the subdivision search tokenizer uses
 * (`shared/data/subdivisions/index.ts`): decomposing first turns "é" into "e" + a combining mark, which is
 * the only thing a character class can then strip.
 *
 * Not a substitute for `Intl.Collator`: a collator compares whole strings and cannot answer "contains", which
 * is what a search box needs.
 */
export const foldForSearch = (raw: string): string =>
  raw
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
